import { Grid2 } from "@mui/material";
import { useMemo } from "react";

import { EnergyType, meterOnlyEnergyTypes } from "api";
import { FiltersContextProvider } from "components/contexts";
import { EnergyChart, RecordsTable } from "components/elements/widgets";
import { useRecordsData } from "components/elements/widgets/EnergyChart/hooks";
import { PageLayout } from "components/layouts";
import { useFormatMessage } from "lang";

import { RecordsFilters } from "./components";

const RecordsPageContent = () => {
  const recordsData = useRecordsData();

  // Drive the meter-only chips off the fetched records, not the momentary
  // live source. `undefined` while there's nothing to judge (empty range)
  // so the picker keeps its legacy fallback instead of wrongly hiding.
  const meterDataAvailable = useMemo(() => {
    const records = recordsData.data;
    if (!records || records.length === 0) return undefined;
    return records.some((record) =>
      [...meterOnlyEnergyTypes].some((metric) => {
        const value = record[metric as EnergyType];
        return !!value && (value.raw > 0 || value.calculated > 0);
      }),
    );
  }, [recordsData.data]);

  return (
    <Grid2 container spacing={3}>
      <RecordsFilters meterDataAvailable={meterDataAvailable} />
      <EnergyChart {...recordsData} showValue data={recordsData.data ?? []} />
      <RecordsTable {...recordsData} />
    </Grid2>
  );
};

export const RecordsPage = () => {
  const formatMessage = useFormatMessage();

  return (
    <FiltersContextProvider
      initialState={{
        dateType: ["month"],
      }}
    >
      <PageLayout pageTitle={formatMessage("pageTitle.records")}>
        <RecordsPageContent />
      </PageLayout>
    </FiltersContextProvider>
  );
};
